export {};

declare global {
	interface String {
		isNumber(): boolean;
		capitalize(): string;
		camelize(): string;
	}
	interface Array<T> {
		inColumns(parts: number): T[][];
	}
	interface Window {
		makeid(length: number): string;
	}
}

String.prototype.isNumber = function (this: string): boolean {
	return /^\d+$/.test(this);
};

String.prototype.capitalize = function (this: string): string {
	return this.charAt(0).toUpperCase() + this.slice(1);
};

window.makeid = function (length: number): string {
	let result = '';
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	const charactersLength = characters.length;
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
};

String.prototype.camelize = function (this: string): string {
	const str = this.toLowerCase()
		.trim()
		.split(/[ -_]/g)
		.map((word) => word.replace(word[0], word[0].toString().toUpperCase()))
		.join('');
	return str.replace(str[0], str[0].toLowerCase());
};

Array.prototype.inColumns = function <T>(this: T[], parts: number): T[][] {
	const result: T[][] = [];
	const chunkSize = Math.ceil(this.length / parts);
	for (let i = 0; i < parts; i++) {
		const start = i * chunkSize;
		const end = start + chunkSize;
		result.push(this.slice(start, end) as T[]);
	}
	return result;
};
